export default {"src":"/_next/static/image/public/icons/search.17412ec70f0b06db595d4f40e98741c4.svg","height":24,"width":24};